import { LabelOrAlternativePipe } from './label-or-alternative.pipe';
import { Pipe } from '@angular/core';
import { SIGN_STICKER_TYPE_CHOICES } from '../../../../model/sign/sticker/sign-sticker-type';

@Pipe({
  name: 'signStickerTypeOrAlternative'
})
export class SignStickerTypeOrAlternativePipe extends LabelOrAlternativePipe {
  constructor() {
    super(SIGN_STICKER_TYPE_CHOICES.CUSTOM.value);
  }
}
